export default __webpack_public_path__ + "assets/95389742a60de2190d5c611680aff2d7.svg";